import React from 'react';
export const NovuContext = React.createContext(null);
//# sourceMappingURL=novu-provider.context.js.map